import { render } from "./App.vue?vue&type=template&id=6747c054"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6747c054&lang=scss"
import "./App.vue?vue&type=style&index=1&id=6747c054&lang=css"

import exportComponent from "C:\\Users\\69472\\Documents\\GitHub\\mcadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__